import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Properties, Property } from '../ui/shared/properties'
import { getImage } from '../../exif-utils'
import { distanceToString } from '../../units'

export default function FileMetadata({
  lastSelectedCaptureFeatures,
  lastSelectedFiles,
  units,
}) {
  const [imgsrc, setImgsrc] = useState([])

  const getPreviewImage = () => {
    if (lastSelectedCaptureFeatures && lastSelectedFiles) {
      const imageFeature = lastSelectedCaptureFeatures[0]
      const file = lastSelectedFiles.find(file => file.id === imageFeature.id)
        .file
      if (file) {
        return getImage(imageFeature, () => file, {
          bands: guessBands(imageFeature),
        })
      }
    }
    return Promise.resolve()
  }

  useEffect(() => {
    getPreviewImage().then(img => {
      if (img) {
        setImgsrc([img.src])
      }
    })
  }, [lastSelectedFiles])

  return (
    (lastSelectedCaptureFeatures && lastSelectedFiles && (
      <div className="tw-my-5">
        {imgsrc.map(src => (
          <img key={src} src={src} className="tw-w-full" />
        ))}
        <div className="tw-my-2">
          {lastSelectedCaptureFeatures.length > 1 && (
            <h5 className="tw-mt-4 tw-mb-2 tw-font-bold">Images in capture</h5>
          )}
          {lastSelectedCaptureFeatures.map(feature => (
            <p
              key={feature.id}
              className="tw-m-0 tw-uppercase tw-mb-0 tw-truncate">
              {feature.properties.filename}
              {!lastSelectedFiles.find(f => f.id === feature.id).file ? (
                <i
                  className="tw-text-danger fas fa-exclamation-triangle"
                  title="This file is missing"
                />
              ) : !feature.geometry ? (
                <i
                  className="tw-text-danger fas fa-exclamation-triangle"
                  title="This file is not georeferenced"
                />
              ) : null}
            </p>
          ))}
        </div>
        <Properties>
          <Property
            title="Camera"
            value={
              [
                lastSelectedCaptureFeatures[0].properties.make,
                lastSelectedCaptureFeatures[0].properties.model,
              ]
                .filter(x => x)
                .join(' ') || 'Unknown'
            }
          />
          <Property
            title="Latitude"
            value={
              (lastSelectedCaptureFeatures[0].properties.latitude &&
                lastSelectedCaptureFeatures[0].properties.latitude.toFixed(
                  6
                )) ||
              '-'
            }
          />
          <Property
            title="Longitude"
            value={
              (lastSelectedCaptureFeatures[0].properties.longitude &&
                lastSelectedCaptureFeatures[0].properties.longitude.toFixed(
                  6
                )) ||
              '-'
            }
          />
          {(lastSelectedCaptureFeatures[0].properties.relative_altitude && (
            <Property
              title="Rel. Altitude"
              value={distanceToString(
                lastSelectedCaptureFeatures[0].properties.relative_altitude,
                units
              )}
            />
          )) || (
            <Property
              title="Abs. Altitude"
              value={distanceToString(
                lastSelectedCaptureFeatures[0].properties.absolute_altitude,
                units
              )}
            />
          )}
        </Properties>
      </div>
    )) || (
      <div>
        <p>NO IMAGE SELECTED</p>
      </div>
    )
  )
}

FileMetadata.propTypes = {
  imageFeature: PropTypes.object,
  file: PropTypes.object,
  units: PropTypes.string,
  lastSelectedCaptureFeatures: PropTypes.array,
  lastSelectedFiles: PropTypes.array,
}

function guessBands(imageFeature) {
  if (
    imageFeature.properties.model &&
    imageFeature.properties.model.toLowerCase() === 'maia'
  ) {
    return 'rrr'
  } else {
    return null
  }
}
